<template>

    <b-modal
        id="set-modal"
        size="md"
        :title="action === 'add' ? t.__('Utwórz zestaw') : t.__('Edytuj zestaw')"
        :ok-title="t.__('Zapisz')"
        :cancel-title="t.__('Anuluj')"
        ok-variant="success"
        no-close-on-backdrop
        @ok="setModalHandleOk"
        @hidden="setModalHandleHide">
        <form @submit.prevent="submitSetForm" @keydown="form.errors.clear($event.target.name)" ref="set-form">

            <div class="row">

                <div class="col-md-6">

                    <div class="form-group">
                        <label for="set_display_name">{{ t.__('Nazwa wyświetlana') }}</label>
                        <input type="text" class="form-control" id="set_display_name" v-model="form.display_name">
                        <small class="form-text text-muted"></small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('display_name')" v-text="form.errors.get('display_name')"></span>
                    </div>

                    <div class="form-group">
                        <label for="set_display_description">{{ t.__('Opis wyświetlany') }}</label>
                        <textarea class="form-control" rows="3" id="set_display_description" v-model="form.display_description"></textarea>
                        <small class="form-text text-muted"></small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('display_description')" v-text="form.errors.get('display_description')"></span>
                    </div>

                </div>

                <div class="col-md-6">

                    <div class="form-group">
                        <label>{{ t.__('Ikona') }}</label>
                        <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'"
                                                   cropAvailable="true" :crop-aspect-ratio="240/320"></file-manager-image-select>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('icon')" v-text="form.errors.get('icon')"></span>
                    </div>

                </div>

            </div>


        </form>
    </b-modal>

</template>

<script>
    export default {

        name: 'PackageContentSetModal',

        props: [
            'package_'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                action: null,
                id: null,
                form: new Vue.prototype.Form({
                    display_name: null,
                    display_description: null,
                    icon: null
                })
            }
        },

        computed: {

        },

        mounted() {

            // Set variables and show modal in edit state
            this.eventHub.$on('package-content-add-set', () => {
                this.action = 'add';
                this.id = null;
                this.form = new Vue.prototype.Form({
                    display_name: null,
                    display_description: null,
                    icon: null
                });
                this.$bvModal.show('set-modal');
            });

            // Set variables and show modal in edit state
            this.eventHub.$on('package-content-edit-set', (set) => {
                this.action = 'edit';
                this.id = set.id;
                this.form = new Vue.prototype.Form({
                    display_name: set.display_name,
                    display_description: set.display_description,
                    icon: {
                        webPath: set.icon_url
                    }
                });
                this.$bvModal.show('set-modal');
            });

        },

        methods: {

            setModalHandleOk(event) {
                event.preventDefault();
                this.submitSetForm();
            },

            setModalHandleHide() {
                this.action = null;
                this.id = null;
                this.form = new Vue.prototype.Form({
                    display_name: null,
                    display_description: null,
                    icon: null
                });
            },

            submitSetForm() {
                this.eventHub.$emit('processing-start');
                if (this.action === 'add') {
                    this.form.post(route('customer::package-content.store-set', {packageId: this.package_.id}))
                        .then(response => {
                            this.eventHub.$emit('package-content-updated', response.data.sets);
                            this.$bvModal.hide('set-modal');
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                        });
                } else if (this.action === 'edit') {
                    this.form.put(route('customer::package-content.update-set', {packageId: this.package_.id, id: this.id}))
                        .then(response => {
                            this.eventHub.$emit('package-content-updated', response.data.sets);
                            this.$bvModal.hide('set-modal');
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                        });
                }

            }

        }

    }
</script>

<style scoped>

</style>
